import { Injectable } from '@angular/core';
import { TranslationLoaderFacade } from './translation-loader.facade';

@Injectable({ providedIn: 'root' })
export class TranslationInitializerService {
  constructor(private translationLoaderFacade: TranslationLoaderFacade) {}

  init(): Promise<void> {
    this.translationLoaderFacade.fetchTranslations();
    return Promise.resolve();
  }
}
